<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('system', ['routerStatusRedirect']),
  },
  methods: {
    ...mapActions('document', ['getDocuments']),
  },
  async created() {
    console.log(`status check ${this.resultName}`)
    if (!this.me?.collectionAccount?.accountNumber) {
      const path = '/bank/collections'
      if ([path].includes(this.$route.path) === false && this.routerStatusRedirect) {
        return await this.$router.replace(path)
      }
      return
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
}
</script>
